let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kWrFZ"), load("eRaYd")]).then(() => parcelRequire('eaE9P'));